function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const CheckmarkCircleIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 10l-1-1c-.2-.2-.5-.2-.7 0l-6 6-2.9-2.9c-.2-.2-.5-.2-.7 0l-1 1c-.2.2-.2.5 0 .7l4.2 4.2c.2.2.5.2.7 0l7.4-7.4c.2-.1.2-.4 0-.6zM13 0C5.8 0 0 5.8 0 13s5.8 13 13 13 13-5.8 13-13S20.2 0 13 0zm0 23C7.5 23 3 18.5 3 13S7.5 3 13 3s10 4.5 10 10-4.5 10-10 10z"
  }));
};
export default CheckmarkCircleIcon;